/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { isAbrRebrandEnabled } from './is-abr-rebrand-enabled';

const ABR_REBRAND_ATTR = 'data-abr-rebrand';

/** 在 document 上挂载 ABR 换肤标记，供 CSS 选择器与后续页面换肤使用 */
export function applyAbrTheme(): void {
  const root = document.documentElement;
  if (isAbrRebrandEnabled()) {
    root.setAttribute(ABR_REBRAND_ATTR, 'true');
  } else {
    root.removeAttribute(ABR_REBRAND_ATTR);
  }
}

export { ABR_REBRAND_ATTR };
